<template>
    <vs-card>          
      <h4 class="font-weight-bold card-title d-flex">
      {{act_memberGrp.bez}}
      </h4>
      <vs-collapse accordion type="border">
        <vs-collapse-item>
              <div slot="header">
                {{$t('OFFERS.MEMBERGRP.SHOW_POS_COLLAPS')}}
              </div>
          <drop-list
            :items="act_memberGrp.member" 
            @reorder="Reordered">
              <template v-slot:item="{item, reorder}">
                <drag :key="item.id" :data="item" :disabled="!editable">
                  <div v-bind:class="{ leftPrimaryBorder: reorder }">
                    <AccountingMember :isOffer="true" :Editable="editable" :key="item.id" :Member="item" :PosNr="item.orderNr" v-on:Saved="RefreshSumBlock" v-on:EditClicked="EditAccountingMemberFromGrp" v-on:DeleteMember="DeleteOfferMember"></AccountingMember>
                  </div>
                </drag>
              </template>
              <template v-slot:inserting-drag-image="{data}">
                  <v-list-item-avatar style="transform:translate(-50%, -50%) scale(1.5)">
                      <img :src="data.avatar">
                  </v-list-item-avatar>
              </template>
              <template v-slot:reordering-drag-image/>
              <template v-slot:feedback="{data}">
                  <v-skeleton-loader
                          type="list-item-avatar-three-line"
                          :key="data.id"
                          style="border-left: 2px solid green; margin-left: -2px;"
                  />
              </template>
          </drop-list> 

        </vs-collapse-item>
      </vs-collapse >    
          <AddOfferMemberDlg ref="addOfferMemberDlgFromMemGrp" v-on:Accepted="MemberAccepted"></AddOfferMemberDlg>
    </vs-card>

</template>
<script>

import helperMethods from '../../helper/staticFuncHelper';
import codeHelper from '../../helper/staticCodeHelper';
import enumHelper from '../../helper/enumHelper';
import { Drag, DropList } from "vue-easy-dnd";
import AccountingMember from './AccountingMember.vue';
import AddOfferMemberDlg from './dialogs/AddOfferMemberDlg';

export default {
  name: "AccountingMemberGrp",
  components:
  {
    AccountingMember,
    Drag,
    DropList,
    AddOfferMemberDlg
  },
  props:['MemberGrp','Editable'],
  data: function (){
     return {
      act_memberGrp: this.MemberGrp,
      editable:this.Editable
     }
  }, 
  mounted () {
  },
  methods:{
      ...helperMethods,
      ...codeHelper,
      ...enumHelper,
      Reordered(props)
      {
        //alert(props.from+" "+props.to);
        // https://github.com/rlemaigre/Easy-DnD

        // Änderung (from -> to) auf das member array anwenden
        props.apply(this.act_memberGrp.member);
        // Sortierung nachziehen
        var sort = {
          motherId: this.offer.id,
          childs: []
        };

        for(var i=0; i < this.act_memberGrp.member.length; i++)
        {
          this.act_memberGrp.member[i].orderNr = i+1;
          var reorderMem = {
              id:this.act_memberGrp.member[i].id,
              orderNr:this.act_memberGrp.member[i].orderNr 
          }
          sort.childs.push(reorderMem);
        }
        this.UpdateOrderNr(sort);

      },
      UpdateOrderNr(data)
      {
        this.$store.dispatch('accounting/reorderOfferMember', data)
        .then(response => {
          if(response.success == true)
          {
            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('ACCOUNTING.ACC_MEMBER.SUCCESS.REORDER')});  
          }
          else
          {
            var text = this.$t('ACCOUNTING.ACC_MEMBER.WARNING.REORDER');
            this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
          }
        }, 
        error =>{
            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('ACCOUNTING.ACC_MEMBER.ERROR.REORDER') + ' ' +error});  
        });
      },  
      EditAccountingMemberFromGrp(member)
      {
        this.$refs.addOfferMemberDlgFromMemGrp.InitDlgData(this.prices,member,this.offer.pricesLastYear,this.offer.country_fk,this.offer.currency_fk);
      },  
      MemberAccepted(){
        this.$emit('MemberSaved');
      },  
      RefreshSumBlock(){
        this.$emit('RefreshSumBlock');
      },
      DeleteOfferMember(parameters){
        this.$emit('DeleteMember',parameters);
      }
  },
  computed:{
    offer()
    {
      var data = {};
      if(this.$store.state.accounting.offer.data != null)
      {
        data = this.$store.state.accounting.offer.data;
      }
      return data;
    },
    prices(){
      var data = null;
      if(this.$store.state.pricelists.valid_pricelists.data != null)
      {
        data = this.$store.state.pricelists.valid_pricelists.data;
      }
      return data;
    },
    
  },
  watch:{

  }
};
</script>